import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";

// css
import styles from "./Auth.module.scss";

// img
import logo from "../../Assets/images/logo.png";
import g1 from "../../Assets/images/ag1.png";
import g2 from "../../Assets/images/ag2.png";

const AuthLayout = () => {
  return (
    <>
      <section
        className={`${styles.authLayout} authLayout position-relative py-3 d-flex align-items-center justify-content-center flex-column`}
        style={{
          zIndex: "9",
          height: "100vh",
        }}
      >
        <img
          src={g1}
          style={{ top: 0, left: 0 }}
          alt=""
          className="img-fluid position-absolute"
        />
        <img
          src={g2}
          style={{ bottom: 0, right: 0 }}
          alt=""
          className="img-fluid position-absolute"
        />
        <Container className="">
          <Row className="justify-content-center">
            <Col md="6" sm="8" className="my-2 py-4 h-100">
              <div
                className={`${styles.formWrpper} formWrpper position-relative mx-auto px-3 py-5`}
                style={{ maxHeight: "85vh" }}
              >
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AuthLayout;
